import React from "react";

interface SectionHeaderProps {
  number: string;
  label: string;
  title: string;
}

export default function SectionHeader({ number, label, title }: SectionHeaderProps) {
  return (
    <div className="mb-14">
      <div className="flex items-baseline gap-3 mb-3">
        <span className="section-number">{number}</span>
        <span className="label-caps">{label}</span>
      </div>
      <h2 className="font-display font-medium text-Text text-4xl md:text-5xl">
        {title}
      </h2>
    </div>
  );
}
